export const packageDescriptionTypes = {
  plan: "plan",
  tourist: "tourist",
  school: "school",
  active: "active",
  incentive: "incentive",
  cityBreak: "city brake",
  nature: "nature",
  theme: "theme",
  winter: "winter",
  description: "description",
};

export const packageDescriptionDefaultText = {
  plan: "Plan wycieczki",
  description: "Informacje praktyczne",
  tourist: "Program wycieczki",
  school: "school",
  active: "active",
  incentive: "incentive",
  cityBreak: "city brake",
  nature: "nature",
  theme: "theme",
  winter: "winter",
};

export type PackageDayDescriptionType = keyof typeof packageDescriptionTypes;
